var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-autocomplete',{attrs:{"clearable":"","items":_vm.cecos,"item-text":"name_code","no-data-text":"Sin CECOS","loading":_vm.loadingCecos,"label":_vm.label},on:{"input":_vm.emitInputCeco,"update:search-input":_vm.getCecosData,"click:clear":function($event){_vm.getCecosData();
      _vm.$emit('cleanCeco');}},model:{value:(_vm.ceco_code),callback:function ($$v) {_vm.ceco_code=$$v},expression:"ceco_code"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }